import { ViewerContentClient, ViewerContentDTOViewerContentType, ViewerContentDTOVersion, IViewerContentClient, ViewerContentType2 } from "@/Generated/ParticaAPI";
import { ViewerContentDTO, ViewerContentType, ViewerContentVersion } from "@/Generated/ParticaAPI";

export interface IViewerContentService {
	saveTOCConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO>;
	getTOCConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO>;
	swapTOCConfig(UrlId: number): Promise<any>;

	getSearchConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO>;
	saveSearchConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO>;
	swapSearchConfig(UrlId: number): Promise<any>;

	getTemplateConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO>;
	saveTemplateConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO>;
	swapTemplateConfig(UrlId: number): Promise<any>;

	getAuthConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO>;
	saveAuthConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO>;
	swapAuthConfig(UrlId: number): Promise<any>;

	getClassicConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO>;
	saveClassicConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO>;
	swapClassicConfig(UrlId: number): Promise<any>;
}

export class ViewerContentService implements IViewerContentService {
	private svc: IViewerContentClient = new ViewerContentClient();


	public async saveSearchConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO> {
		if (data.viewerContentType !== ViewerContentDTOViewerContentType.Search) {
			throw new Error("Invalid ContentType.");
		}
		if (data.version === ViewerContentDTOVersion.Live) {
			throw new Error("You cannot save a live version of the content. Use swap to make a configurtaion live.");
		}
		return await this.svc.saveViewerContent(data);
	}
	public async getSearchConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO> {
		let data = await this.svc.getViewerContent(UrlId, ViewerContentType.Search, version);
		if (data.id === undefined) {
			data = new ViewerContentDTO();
			data.version = version === ViewerContentVersion.Live ? ViewerContentDTOVersion.Live : ViewerContentDTOVersion.Preview;
			data.customerUrlId = UrlId;
			data.id = 0;
			data.viewerContentType = ViewerContentDTOViewerContentType.Search;
			if (data.version === ViewerContentDTOVersion.Preview) {
				data.content = `{"advanced":false}`;
			}
		}
		return data;
	}
	public async swapSearchConfig(UrlId: number): Promise<any> {
		return await this.svc.swapViewerContent(UrlId, ViewerContentType2.Search);
	}


	public async saveTemplateConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO> {
		if (data.viewerContentType !== ViewerContentDTOViewerContentType.Template) {
			throw new Error("Invalid ContentType.");
		}
		if (data.version === ViewerContentDTOVersion.Live) {
			throw new Error("You cannot save a live version of the content. Use swap to make a configurtaion live.");
		}
		return await this.svc.saveViewerContent(data);
	}
	public async getTemplateConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO> {
		let data = await this.svc.getViewerContent(UrlId, ViewerContentType.Template, version);
		if (data.id === undefined) {
			data = new ViewerContentDTO();
			data.version = version === ViewerContentVersion.Live ? ViewerContentDTOVersion.Live : ViewerContentDTOVersion.Preview;
			data.customerUrlId = UrlId;
			data.id = 0;
			data.viewerContentType = ViewerContentDTOViewerContentType.Template;
			if (data.version === ViewerContentDTOVersion.Preview) {
				data.content =
					`{
						"header":"","footer":"","home":"","issue":"","article":"","section":"","login":"","logout":"","past-issues":"","replica":"",
						"landing":"","landing-secure":""}`;
			}
		}
		return data;
	}
	public async swapTemplateConfig(UrlId: number): Promise<any> {
		return await this.svc.swapViewerContent(UrlId, ViewerContentType2.Template);
	}





	public async saveClassicConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO> {
		if (data.viewerContentType !== ViewerContentDTOViewerContentType.Classic) {
			throw new Error("Invalid ContentType.");
		}
		if (data.version === ViewerContentDTOVersion.Live) {
			throw new Error("You cannot save a live version of the content. Use swap to make a configurtaion live.");
		}
		return await this.svc.saveViewerContent(data);
	}
	public async getClassicConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO> {
		let data = await this.svc.getViewerContent(UrlId, ViewerContentType.Classic, version);
		if (data.id === undefined) {
			data = new ViewerContentDTO();
			data.version = version === ViewerContentVersion.Live ? ViewerContentDTOVersion.Live : ViewerContentDTOVersion.Preview;
			data.customerUrlId = UrlId;
			data.id = 0;
			data.viewerContentType = ViewerContentDTOViewerContentType.Classic;
			if (data.version === ViewerContentDTOVersion.Preview) {
				data.content =
					`{
	"issuemapping":""
}`;
			}
		}
		return data;
	}
	public async swapClassicConfig(UrlId: number): Promise<any> {
		return await this.svc.swapViewerContent(UrlId, ViewerContentType2.Classic);
	}






	public async saveAuthConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO> {
		if (data.viewerContentType !== ViewerContentDTOViewerContentType.Authentication) {
			throw new Error("Invalid ContentType.");
		}
		if (data.version === ViewerContentDTOVersion.Live) {
			throw new Error("You cannot save a live version of the content. Use swap to make a configurtaion live.");
		}
		return await this.svc.saveViewerContent(data);
	}


	public async swapAuthConfig(UrlId: number): Promise<any> {
		return await this.svc.swapViewerContent(UrlId, ViewerContentType2.Authentication);
	}

	public async getAuthConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO> {
		let data = await this.svc.getViewerContent(UrlId, ViewerContentType.Authentication, version);
		if (data.id === undefined) {
			data = new ViewerContentDTO();
			data.version = version === ViewerContentVersion.Live ? ViewerContentDTOVersion.Live : ViewerContentDTOVersion.Preview;
			data.customerUrlId = UrlId;
			data.id = 0;
			data.viewerContentType = ViewerContentDTOViewerContentType.Authentication;
			if (data.version === ViewerContentDTOVersion.Preview) {
				data.content =
					`{
						"id": "",
						"redirects": {
						  "success": "/",
						  "fail": "/landing"
						},
						"authorization": {
						  "debug": true,
						  "inparams": [
							{
							  "source": "form",
							  "name": "username"
							},
							{
							  "source": "form",
							  "name": "password"
							}
						  ],
						  "flow": "api",
						  "endpoint": {
							"url": "https://",
							"method": "POST",
							"prms": [ {
								"from": "username",
								"name": "iEmailAddr"
							  }],
							"contenttype": "json"
						  },
						  "rules": [
							{
							  "check": "status",
							  "rule": "200",
							  "success": true,
							  "message": ""
							},
							{
							  "check": "status",
							  "rule": "400",
							  "success": false,
							  "message": ""
							},							
							{
							  "check": "status",
							  "rule": "404",
							  "success": false,
							  "message": ""
							},
							{
							  "check": "status",
							  "rule": "500",
							  "success": false,
							  "message": ""
							},
							{
								"check": "default",
								"message": "Default not logged in."
							  }  
						  ]
						}
					  }`;
			}
		}
		return data;
	}

	public async getTOCConfiguration(UrlId: number, version: ViewerContentVersion): Promise<ViewerContentDTO> {
		let data = await this.svc.getViewerContent(UrlId, ViewerContentType.Tableofcontents, version);
		if (data.id === undefined) {
			data = new ViewerContentDTO();
			data.version = version === ViewerContentVersion.Live ? ViewerContentDTOVersion.Live : ViewerContentDTOVersion.Preview;
			data.customerUrlId = UrlId;
			data.id = 0;
			data.viewerContentType = ViewerContentDTOViewerContentType.Tableofcontents;
			if (data.version === ViewerContentDTOVersion.Preview) {
				data.content = `
{
	"enabled": false,
	"includedSections": [
		"*"
	],
	"excludedSections": [
		""
	]
}`;
			}
		}
		return data;
	}
	public async saveTOCConfiguration(data: ViewerContentDTO): Promise<ViewerContentDTO> {
		if (data.viewerContentType !== ViewerContentDTOViewerContentType.Tableofcontents) {
			throw new Error("Invalid ContentType.");
		}
		if (data.version === ViewerContentDTOVersion.Live) {
			throw new Error("You cannot save a live version of the content. Use swap to make a configurtaion live.");
		}
		return await this.svc.saveViewerContent(data);
	}
	public async swapTOCConfig(UrlId: number): Promise<any> {
		return await this.svc.swapViewerContent(UrlId, ViewerContentType2.Tableofcontents);
	}



}
